const en = {
  app: {
    label: {
      true: 'Yes',
      false: 'No',
    },
    loginWidget: {
      email: 'E-Mail',
      forgotPassword: 'Forgot password?',
      login: 'Login',
      loginWelcome: 'Welcome back. Log in with your registered data.',
      next: 'Next',
      password: 'Password',
      title: 'Login',
    },
    resetWidget: {
      title: 'Forgot Password?',
      instructions:
        'Please enter the address associated with your account. We’ll send you reset instructions.',
      emailLabel: 'Email Address',
      emailPlaceholder: 'Enter your Email Address',
      back: 'Back to Login',
      submit: 'Submit',
      submitSso: 'Go to single sign-on portal',
    },
    resetConfirmationWidget: {
      title: 'New password requested',
      confirmation: 'Please check your email inbox for further instruction.',
      back: 'Back to Login',
    },
    changePasswordWidget: {
      title: 'Set password',
      forcedTitle: 'Reset password',
      instructions:
        'Set your new personal password minding our password security recommendations:',
      placeholder: 'Password',
      newPasswordLabel: 'Set new password',
      confirmationLabel: 'Repeat new password',
      confirmationError: "Password confirmation doesn't match password",
      backToLogin: 'Go to Login',
      back: 'Back',
      submit: 'Set Password',
      recommendations: {
        characterCount: 'min. 10 characters',
        containing: 'containing',
      },
    },
    logout: 'Log out',
    inactivityLogout:
      'You were logged out due to inactivity. Please log in with your credentials again.',
    switchToLightTheme: 'Switch to light theme',
    switchToDarkTheme: 'Switch to dark theme',
    changePassword: 'Change password',
    page: {
      genericError: 'An error occurred',
      retry: 'Try again',
      notLoadedTitle: 'Page could not be loaded',
      notLoadedErrorText:
        'The page you are looking for doesn’t exist or an error occurred. Please try again or contact your admin.',
      pageContentErrorTitle: 'Page content error',
      contentNotFoundError:
        'There was a problem loading the content.  Please refresh the page or try again later.',
      backToDashboard: 'Back to Dashboard',
      close: 'Close Details Page',
    },
    pageFilter: {
      placeholder: 'All',
      reset: 'Reset filters',
      calendarFilter: {
        defaultTitle: 'Date',
        placeholder: 'Select date',
      },
      dateRangeFilter: {
        placeholderFrom: 'From',
        placeholderTo: 'To',
      },
    },
    pagination: {
      summary:
        '{{firstShownEntry}} - {{lastShownEntry}} of {{totalEntries}} Entries',
      summaryShort: '{{totalEntries}} of {{totalEntries}} Entries',
      selectItem: '{{entries}} per page',
      selectedRows: '{{selectedRowsCount}} selected',
      entryLimit: ' (Limited to {{totalEntries}} Entries)',
    },
    table: {
      tooltip: {
        maliciousContent:
          'Our checks conducted indicate that the file uploaded may contain some active or even malicious content.',
      },
      searchResultPagination: '{{shownResults}} of {{totalResults}} results',
      customizationModal: {
        title: 'Table settings',
        divider: 'Move fixed columns above this bar',
        resetChanges: 'Reset all changes',
        cancel: 'Cancel',
        apply: 'Save & Exit',
        selectAll: 'Select all',
      },
      filterModal: {
        title: 'Filter settings',
        resetChanges: 'Remove all filters',
        cancel: 'Cancel',
        apply: 'Save & Exit',
        selectAll: 'Select all',
      },
      showMoreEntry_one: '+ {{ count }} more entry',
      showMoreEntry_other: '+ {{ count }} more entries',
      workflowActionModal: {
        apply: 'Confirm',
        cancel: 'Cancel',
        close: 'Close',
        successMessage: 'The action has been successfully executed.',
        fileUploadRequired: 'At least one file is required.',
        actionSuccessfulCountTimes_one:
          'The action was successful for {{ count }} item',
        actionSuccessfulCountTimes_other:
          'The action was successful for {{ count }} items',
        actionFailedCountTimes_one: 'but failed for {{ count }} item',
        actionFailedCountTimes_other: 'but failed for {{ count }} items',
      },
      documentSigning: {
        initializationErrorNotification:
          'An error occurred while initializing the document signing process',
        finalizingErrorNotification:
          'An error occurred while finalizing the document signing process',
        finalizingNotification: 'Finalizing document signing',
        successNotification: 'Document signing was successful',
      },
      deleteConfirmation: {
        cancel: 'Cancel',
        apply: 'Delete',
        title: 'Delete',
        message_one: 'Do you really want to delete {{count}} row?',
        message_other: 'Do you really want to delete {{count}} rows?',
      },
    },
    datepicker: {
      qtd: 'Quarter to date',
      qtdShort: 'QTD',
      ytd: 'Year to date',
      ytdShort: 'YTD',
      ltm: 'Last twelve months',
      ltmShort: 'LTM',
      sinceInception: 'All dates until today',
      sinceInceptionShort: 'Since Inception',
    },
    select: {
      noOptionsAvailable: 'No options available',
      noOptionsFound: "No options for '{{query}}'",
      selectAbove: 'Select all of the above',
    },
    search: {
      placeholder: 'Search',
    },
    noAccessError: {
      headline: 'Application access denied',
      message: 'You are not authorized to access this application.',
      resolution:
        'If you think this is an error, please request assistance from your support contact.',
      logoutButton: 'Logout',
    },
    notifications: {
      goToPage: 'Go to page',
      excelExport: {
        error: 'Downloading data <0>({{fileName}})</0> for Excel failed.',
        loading: 'Downloading data <0>({{fileName}})</0> for Excel.',
        success:
          'Data <0>({{fileName}})</0> for Excel successfully downloaded.',
      },
      bulkDownload: {
        error_one: 'Generating archive for {{count}} document failed.',
        error_other: 'Generating archive for {{count}} documents failed.',
        loading_one: 'Generating archive for {{count}} document.',
        loading_other: 'Generating archive for {{count}} documents.',
        success_one: 'Download of archive with {{count}} document started.',
        success_other: 'Download of archive with {{count}} documents started.',
      },
      downloadRow: {
        error: 'Failed to load table row data: {{- message}}',
        loading_one: 'Loading data for {{count}} row',
        loading_other: 'Loading data for {{count}} rows',
        success_one: 'Starting to download data for {{count}} row',
        success_other: 'Starting to download data for {{count}} rows',
      },
      rowRequest: {
        error: 'Failed to execute "{{label}}" request: {{- message}}',
        loading_one: 'Executing "{{label}}" request for {{count}} row',
        loading_other: 'Sending "{{label}}" request for {{count}} rows',
        success_one:
          'Successfully executed "{{label}}" request for {{count}} row',
        success_other:
          'Successfully executed "{{label}}" request for {{count}} rows',
      },
      markAsRead: {
        error: 'Marking documents as read failed.',
        success: '{{count}} document(s) successfully marked as read.',
      },
      markAsUnread: {
        error: 'Marking documents as unread failed.',
        success: '{{count}} document(s) successfully marked as unread.',
      },
      delete: {
        error: 'Deleting rows failed.',
        success: '{{count}} row(s) successfully deleted.',
      },
    },
    dataRefresh: {
      label: 'Latest data refresh',
      tooltip: 'Latest data refresh: {{formattedDate}}',
    },
    disclaimer: {
      accept: 'I agree',
      cancel: 'Cancel',
      defaultTitle: 'Disclaimer',
    },
    widget: {
      action: {
        label: {
          additionalInformation: 'Additional information',
          bulkActions: 'Bulk actions',
          closeFullscreen: 'Exit fullscreen view',
          customFilter: 'Datatable custom filters',
          customization: 'Datatable customization',
          delete: 'Delete',
          download: 'Download Documents',
          edit: 'Edit',
          excelDownloadFiltered: 'Download filtered data for Excel',
          excelDownloadReadOnly: 'Download audit trail for Excel',
          excelDownloadUnFiltered: 'Download all data for Excel',
          imageDownload: 'Download chart as image',
          imageDownloadWithBackground:
            'Download chart as image with background',
          initFoundOperation: 'Create fund operation',
          markAsRead: 'Mark as read',
          markAsUnread: 'Mark as unread',
          openInFullscreen: 'Open in fullscreen',
          shareActions: 'Share actions',
          createRow: 'Create row',
          openDetailPage: 'Open {{label}} details',
        },
        tooltip: {
          excelDownloadFiltered:
            'Download data with current filters applied. All available table columns will be included in download. Customized table columns do not apply.',
          excelDownloadUnFiltered:
            'Download data with no filters applied. All available table columns will be included in download. Customized table columns do not apply.',
          excelDownloadReadOnly:
            'Download data as read-only with current filters applied. All available table columns will be included in download. Customized table columns do not apply.',
        },
      },
    },
    upload: {
      zipUploadModal: {
        headline: 'Upload documents',
      },
      title: 'Drag and Drop your files here or ',
      subtitle: 'Choose files.',
      permittedFormats: 'Permitted formats',
      maxSize: 'Maximum size per file',
      maxUploads: 'Maximum uploads',
      upload: 'Upload',
      uploadDocuments: 'Upload Documents',
      uploading: 'Uploading',
      cancel: 'Cancel',
      close: 'Close',
      okay: 'Okay',
      uploadFailed: 'Upload failed',
      rejected: 'Rejected Files',
      addedToUpload: 'Added Files',
      fileSummary_one: '{{ count }} File | {{ totalFileSize }}',
      fileSummary_other: '{{ count }} Files | {{ totalFileSize }}',
      info: {
        progress_one:
          '{{ count }} of {{ total }} Files is uploaded successfully.',
        progress_other:
          '{{ count }} of {{ total }} Files are uploaded successfully.',
        problemCount_one: 'There was a problem uploading {{ count }} file.',
        problemCount_other: 'There was a problem uploading {{ count }} files.',
      },
      uploadedFiles: 'Uploads',
      conditionalFilterOptionsError:
        'A system error occurred while loading meta data. Please cancel this operation and try again.',
      uploadZip: 'Upload zip-archive',
      back: 'Back',
      extractMetaData: {
        title: 'Meta data read from document',
        checkBtnLabel: 'Check file-specific metadata',
        fileName: 'File Name',
        size: 'Size',
        totalFiles_one:
          'Meta data from {{ success }} of {{ count }} file was read successfully.',
        totalFiles_other:
          'Meta data from {{ success }} of {{ count }} files was read successfully.',
        failedToExtract_one:
          'An error occurred when setting meta data for {{ count }} file.',
        failedToExtract_other:
          'An error occurred when setting meta data for {{ count }} files.',
        readFromDocument: 'Read from file name',
      },
      noFiles: 'No files to upload',
      hideAndSelectAllFieldError:
        'Field {{title}} is configured as hide and select all which only supports a maximum 10 items.',
    },
    backToPage: 'Back to Page',
    forms: {
      validationErrors: {
        inputIsRequired: 'Input is required',
        minMaxNumberError: 'Expected {{expected}}',
        minDateError: 'Date must not be before ',
        maxDateError: 'Date must not be after ',
        shouldBeMaxError:
          'Max of all partial sale should not be less than exit date',
      },
    },
    updateTableRow: {
      title_one: 'Edit entry ({{count}} item)',
      title_other: 'Edit entries ({{count}} items)',
      titleForTypeDoc_one: 'Edit document ({{count}} item)',
      titleForTypeDoc_other: 'Edit documents ({{count}} items)',
      updateError: 'Error updating {{errorRowCount}} items',
      cancel: 'Cancel',
      submit: 'Submit',
    },
    navigation: {
      dynamicNavSection: {
        title: 'Detail Pages',
        closeAll: 'Close all',
        errorNotification: 'Error closing details page links!',
      },
    },
    initFundOperation: {
      title: 'Create fund operation',
      cancel: 'Cancel',
      submit: 'Submit',
      successMessage: 'The fund operation has been successfully created.',
      fundLoadingError:
        'A system error occurred while loading fund data. Please cancel this operation and try again.',
      currencyLoadingError:
        'A system error occurred while loading currency data. Please cancel this operation and try again.',
      error:
        'A system error occurred. Please cancel this operation and try again.',
    },
    createRow: {
      title: 'Create row',
      successMessage: 'The row has been successfully created.',
      error:
        'A system error occurred. Please cancel this operation and try again.',
      fileUploadRequired: 'At least one file is required.',
      cancel: 'Cancel',
      submit: 'Submit',
      okay: 'Okay',
      submitting: 'Submitting',
    },
    tableSidebarWidget: {
      closeSidebar: 'Close sidebar',
      download: 'Download',
      noDocumentsAvailable: 'No documents available',
      openInPage: 'Open in Documents',
      widgetTitle: 'Details',
      errorText: 'There was a problem loading related documents.',
    },
    vegaChartWidget: {
      groupingError: 'Column grouping is not configured for the datacolumns',
    },
  },
} as const;

export default en;
